export const LIST_CATEGORIES = 'LIST_CATEGORIES';
export const GET_CATEGORY = 'GET_CATEGORY';
export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const LIST_CATEGORY_GROUPS = 'LIST_CATEGORY_GROUPS';
export const LIST_CATEGORY_GROUPS_PAGINATED = 'LIST_CATEGORY_GROUPS_PAGINATED';
export const GET_CATEGORY_GROUP = 'GET_CATEGORY_GROUP';
export const CREATE_CATEGORY_GROUP = 'CREATE_CATEGORY_GROUP';

export const END_URL = {
  CATEGORIES: '/categories',
  CATEGORY_GROUPS: '/category/groups',
  CATEGORY_GROUPS_LIST: '/category/groups/list',
};

export const VALIDATION = {
  INVAL_EMAIL: 'Invalid Email',
  SYSTEM_ERROR: 'System Error',
  EMPTY_CLIENT: 'Please select at least one advertiser',
  SPECIAL_CHARS: 'Special characters are not allowed',
  SPACES_ONLY: 'Description cannot contain only spaces',

  CATEGORY_NAME_REQUIRED: 'Category Name is required',
  CATEGORY_NAME_MIN_LENGTH:
    'Category Name should not be less than 3 characters',
  CATEGORY_NAME_MAX_LENGTH:
    'Category Name should not be more than 50 characters',

  CATEGORY_GROUP_REQUIRED: 'Category Group is required',
  CATEGORY_GROUP_MIN_LENGTH:
    'Category Group should not be less than 3 characters',
  CATEGORY_GROUP_MAX_LENGTH:
    'Category Group should not be more than 50 characters',

  CATEGORY_DESC_MAX_LENGTH:
    'Category Description should not be more than 255 characters',
  GROUP_DESC_MAX_LENGTH:
    'Category Group Description should not be more than 255 characters',
};

export const TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  DEACTIVE: 'Deactive',
  ACTIVE: 'Active',
  ACTIVATE: 'Activate',
  DEACTIVATE: 'Deactivate',
};

export const STRING = {
  CHARACTER_LENGTH: 3,
  NAME_MAX_LENGTH: 50,
  DESCRIPTION_MAX_LENGTH: 255,
  CATEGORY: 'Category',
  MODAL_TITLE: 'Are you sure?',
  YES: 'Yes',
  NO: 'No',
  ADD_NEW: 'Add New Category',
  ADD_NEW_GROUP: 'Add New Category Group',
  NO_CAT_DATA: 'No categories found',
  NO_CAT_GROUP_DATA: 'No category groups found',
  COL: [
    { name: 'id', title: 'ID' },
    { name: 'category', title: 'Category' },
    { name: 'category-group', title: 'Category Group' },
    { name: 'created_at', title: 'Created At' },
    { name: 'updated_at', title: 'Updated At' },
    { name: 'actions', title: 'Actions' },
  ],
  COL_STYLES: [
    { columnName: 'id' },
    { columnName: 'category' },
    { columnName: 'category-group' },
    { columnName: 'created_at' },
    { columnName: 'updated_at' },
    { columnName: 'actions', align: 'center' },
  ],
};

export const CATEGORY = {
  GROUP: 'category-group',
  PAGE_SIZE: 10,
};

export const TOAST_MESSAGES = {
  CREATE: 'category created successfully',
  UPDATE: 'category updated successfully',
  GROUP_CREATE: 'category group created successfully',
  GROUP_UPDATE: 'category group updated successfully',
  DEACTIVE: 'category deactivated successfully',
  ACTIVE: 'category activated successfully',
};

export const GROUP_COLUMNS = [
  { name: 'id', title: 'ID' },
  { name: 'name', title: 'Category Group' },
  { name: 'description', title: 'Description' },
  { name: 'created_at', title: 'Created At' },
  { name: 'updated_at', title: 'Updated At' },
  { name: 'actions', title: 'Actions' },
];

export const GROUP_COL_STYLES = [
  { columnName: 'id' },
  { columnName: 'actions', align: 'center' },
  { columnName: 'description' },
  { columnName: 'created_at' },
  { columnName: 'updated_at' },
];
